<template>
    <div class="form-group" @keydown.enter.prevent.self>
        <label v-if="label" :for="name" class="form-label"
            >{{ label }}
            <span v-if="required" class="text-black astric"> *</span>
            <template v-if="hasTooltip">
                <TooltipIcon :content="tooltipText" />
            </template>
        </label>

        <div class="select-with-style">
            
            <v-select
                :id="name"
                ref="selectRef"
                v-model="vModel"
                :clearable="clearable"
                :disabled="disabled || readonly"
                :multiple="multiple"
                :name="name"
                :options="_options"
                :placeholder="computedPlaceholder"
                :searchable="true"
                :close-on-select="!multiple"
                :reduce="(option) => option.id"
                :label="labelField"
                :allow-create="allowCreate"
                :on-create-tag="onCreateTag"
                class="d-block w-100"
                @search:blur="onSearchBlur"
                @search:focus="onSearchFocus"
                @option:selected="onSelect"
                @option:deselected="onDeselect"
                @update:modelValue="onChange"
               
            >
                <!-- <template #option="option">

          <div class="option-item">
            <span v-if="option[optionAvatarField] || option.option[optionAvatarField]" class="option-avatar">
              <img style="width: 20px; height: 20px;"
                :alt="option.name || option.option.name"
                :src="option[optionAvatarField] || option.option[optionAvatarField]"
              />
            </span>
            <span class="option-text">{{ option.name || option.option.name }}</span>
          </div>
        </template> -->

                <template #option="option">
                    <!-- Action row -->
                    <div
                        v-if="
                            actionOptionEnabled &&
                            ((option && option.id === actionOptionValue) ||
                                (option &&
                                    option.option &&
                                    option.option.id === actionOptionValue))
                        "
                        class="option-item"
                    >
                        <span class="option-avatar">
                            <img
                                style="
                                    padding: 1px;
                                    width: 25px;
                                    height: 25px;
                                    background: var(--color-gray-50);
                                    border-radius: 50%;
                                "
                                alt=""
                                src="../../assets/img/add.png"
                            />
                        </span>

                        <span class="option-text">{{ actionOptionLabel }}</span>
                    </div>

                    <!-- Normal row -->
                    <div v-else class="option-item">
                        <span class="option-avatar">
                            <img
                                v-if="
                                    showOptionAvatar &&
                                    (getPath(option, optionAvatarField) ||
                                        getPath(
                                            option.option,
                                            optionAvatarField
                                        ))
                                "
                                style="
                                    padding: 1px;
                                    width: 35px;
                                    height: 35px;
                                    background: var(--color-gray-50);
                                    border-radius: 50%;
                                "
                                :alt="
                                    getPath(option, labelField) ||
                                    getPath(option.option, labelField) ||
                                    option.name ||
                                    option.option?.name ||
                                    'avatar'
                                "
                                :src="
                                    getPath(option, optionAvatarField) ||
                                    getPath(option.option, optionAvatarField)
                                "
                            />
                            <img
                                v-if="
                                    showOptionAvatar &&
                                    !getPath(option, optionAvatarField) &&
                                    !getPath(option.option, optionAvatarField)
                                "
                                style="
                                    padding: 1px;
                                    width: 35px;
                                    height: 35px;
                                    background: var(--color-gray-50);
                                    border-radius: 50%;
                                "
                                :alt="
                                    getPath(option, labelField) ||
                                    getPath(option.option, labelField) ||
                                    option.name ||
                                    option.option?.name ||
                                    'avatar'
                                "
                                src="../../assets/img/default-avatar.jpg"
                            />
                        </span>
                        <span class="option-text">
                            {{
                                getPath(option, labelField) ||
                                getPath(option.option, labelField) ||
                                option.name ||
                                option.option?.name
                            }}
                        </span>
                    </div>
                </template>
            </v-select>
        </div>
        <small
            v-if="errors && errors[error_name || name]"
            class="form-text text-danger"
            v-text="errors[error_name || name][0]"
        />
    </div>
</template>

<script>
import i18n from "@/lang";
// import addIcon from '../../assets/img/add.png'

const { t } = i18n.global;
export default {
    emits: ["action", "change", "keyup", "select", "deselected"],
    props: {
        label: {
            type: String,
        },
        teleported: {
            type: Boolean,
            default: true,
        },

        name: {
            type: String,
            required: true,
        },

        model: {
            type: [Object, Array],
            required: true,
        },

        errors: {
            type: [Object, Array],
            // required: true
        },

        options: {
            type: [Array],
            required: true,
        },

        labelField: {
            type: String,
            required: false,
            default: "label",
        },

        valueField: {
            type: String,
            default: "id",
        },

        multiple: {
            type: Boolean,
        },

        disabled: {
            type: Boolean,
        },
        readonly: {
            type: Boolean,
            default: false,
        },

        error_name: {
            type: String,
        },

        required: {
            type: Boolean,
        },
        reduce: {
            type: Function,
            default: (value) => value,
        },
        selectAllOption: {
            type: Boolean,
            default: false,
        },
        remote: {
            type: Boolean,
            required: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        placeholder: {
            type: String,
        },
        allowCreate: {
            type: Boolean,
            default: false,
        },
        onCreateTag: {
            type: Function,
            default: null,
        },
        // Optional first option as an action button (e.g., Add New Client)
        actionOptionEnabled: {
            type: Boolean,
            default: false,
        },
        actionOptionLabel: {
            type: String,
            default: "",
        },
        actionOptionValue: {
            type: [String, Number],
            default: -9999,
        },
        showOptionAvatar: {
            type: Boolean,
            default: false,
        },
        optionAvatarField: {
            type: String,
            default: "avatar",
        },
        avatarSize: {
            type: Number,
            default: 20,
        },
        hasTooltip: {
            type: Boolean,
            default: false,
        },
        tooltipText: {
            type: String,
            default: "",
        },
    },

    computed: {
        computedPlaceholder() {
            return this.placeholder
                ? this.placeholder
                : `${t("messages.select")} ${this.label || t("option")}`;
        },
        vModel: {
            get: function () {
                // Retrieve the raw value from the model
                const raw = _.get(this.model, this.name);

                // For multiple selects, vue-select expects an array of values
                if (this.multiple) {
                    if (Array.isArray(raw)) {
                        return raw;
                    }
                    // Gracefully coerce primitives or undefined to an empty array
                    return [];
                }

                // Single select - return the raw value, vue-select will handle the display
                return raw !== undefined && raw !== null ? raw : null;
            },
            // setter
            set: function (newValue) {
                // If the special action option is chosen, trigger action and do not persist value
                if (
                    !this.multiple &&
                    this.actionOptionEnabled &&
                    newValue === this.actionOptionValue
                ) {
                    this.$emit("action");
                    return;
                }
                if (this.multiple) {
                    // Ensure we always set an array for multiple
                    const safeArray = Array.isArray(newValue) ? newValue : [];
                    _.set(this.model, this.name, safeArray);
                    return;
                }
                _.set(this.model, this.name, newValue);
            },
        },
        _options() {
            // Ensure options is always an array
            let options = Array.isArray(this.options) ? [...this.options] : [];

            // Check if component is multiple, hence prepend select all option
            if (this.multiple && !_.isEmpty(options) && this.selectAllOption) {
                if (!this.haveAllOption()) {
                    options.unshift({
                        id: -1,
                        [`${this.labelField}`]: t("select_all"),
                    });
                }
            }

            // Add action option if enabled
            if (this.actionOptionEnabled && !this.multiple) {
                options.unshift({
                    id: this.actionOptionValue,
                    [`${this.labelField}`]: this.actionOptionLabel,
                });
            }

            return options;
        },
    },

    watch: {
        //  options(newVal, oldVal) {
        //     let newIDs = newVal.map(item => item.id);
        //     let currentModel = _.get(this.model, this.name);
        //
        //     // Check if model is array
        //     if (Array.isArray(currentModel)) {
        //         // filter model
        //         let newModel = currentModel.filter(function (el) {
        //             return newIDs.includes(el.id);
        //         });
        //         _.set(this.model, this.name, newModel);
        //     }
        // }
    },

    methods: {
       
        onSelect(option) {
            // Handle action option selection
            if (
                this.actionOptionEnabled &&
                option &&
                option.id === this.actionOptionValue
            ) {
                this.$emit("action");
                return;
            }

            // Emit select event for parent components
            this.$emit("select", option ? option.id : option);

            this.onChange(option ? option.id : option);
        },
        onDeselect(option) {
            this.$emit("deselected", option ? option.id : option); // ✅ fix event name
        },
        onChange(value) {
            // Handle action option selection
            if (this.actionOptionEnabled && value === this.actionOptionValue) {
                this.$emit("action");
                return;
            }
            this.$emit("change", value);
            this.$emit("keyup");
        },
        onSearchBlur() {
            // Handle search blur if needed
        },
        onSearchFocus() {
            // Handle search focus if needed
        },
        async onTagCreated(tagLabel) {
            // Handle tag creation event: create on server, then replace temporary label with new ID
            if (!this.onCreateTag) return;
            try {
                const created = await this.onCreateTag(tagLabel);
                const newId = created?.id ?? created?.value ?? created;

                if (this.multiple) {
                    const current = Array.isArray(this.vModel)
                        ? [...this.vModel]
                        : [];
                    const idx = current.lastIndexOf(tagLabel);
                    if (idx !== -1) {
                        current.splice(idx, 1, newId);
                    } else {
                        current.push(newId);
                    }
                    _.set(this.model, this.name, current);
                } else {
                    _.set(this.model, this.name, newId);
                }
            } catch (e) {
                // swallow errors; validation will handle UI
            }
        },
        onSearch(value) {
            if (this.remote) {
                this.$emit("searchServerSide", value);
            }
        },
        haveAllOption() {
            return this.options.some((item) => item.id === -1);
        },
        haveAllOption() {
            return this.options.some((item) => item.id === -1);
        },
        getPath(obj, path) {
            if (!obj || !path) return undefined;
            return path
                .split(".")
                .reduce((o, k) => (o == null ? undefined : o[k]), obj);
        },
    },
};
</script>

<style scoped>
.select-with-style {
    position: relative;
}

/* Vue Select Base Styles */
:deep(.vs__dropdown-toggle) {
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    min-height: 48px;
    padding: 8px 12px;
}

/* Focus styles */
:deep(.vs--focused .vs__dropdown-toggle) {
    border-color: #9b8cff;
    box-shadow: inset 0 0 0 2px #9b8cff, 0 0 0 3px rgba(155, 140, 255, 0.25);
}

/* Single select input */
:deep(.vs--single .vs__selected) {
    line-height: 32px;
    font-size: 14px;
    color: #111827;
}

/* Multiple select tags */
:deep(.vs--multiple .vs__selected) {
    background-color: #f8f8f8;
    color: #000;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    margin: 2px 4px 2px 0;
    padding: 4px 8px;
    font-size: 14px;
    font-weight: 500;
}

/* Multiple select container */
:deep(.vs--multiple .vs__selected-options) {
    max-height: 120px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

:deep(.vs--multiple .vs__selected-options::-webkit-scrollbar) {
    width: 6px;
}

:deep(.vs--multiple .vs__selected-options::-webkit-scrollbar-track) {
    background: transparent;
}

:deep(.vs--multiple .vs__selected-options::-webkit-scrollbar-thumb) {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
}

:deep(.vs--multiple .vs__selected-options::-webkit-scrollbar-thumb:hover) {
    background: rgba(0, 0, 0, 0.3);
}

/* Dropdown menu */
:deep(.vs__dropdown-menu) {
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
    border: 1px solid #e2e8f0;
}

/* Dropdown options */
:deep(.vs__dropdown-option) {
    padding: 8px 12px;
    font-size: 14px;
}

:deep(.vs__dropdown-option--highlight) {
    background-color: #f3f4f6;
    color: #111827;
}

:deep(.vs__dropdown-option--selected) {
    background-color: #9b8cff;
    color: white;
}

/* Clear button */
:deep(.vs__clear) {
    fill: #6b7280;
}

:deep(.vs--disabled .vs__clear) {
  display: none !important;
}


/* Open indicator */
:deep(.vs__open-indicator) {
    fill: #6b7280;
}

/* Disabled state */
:deep(.vs--disabled .vs__dropdown-toggle) {
    background-color: #f9fafb;
    color: #6b7280;
}

/* Option item with avatar */
.option-item {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.option-avatar img {
    border-radius: 50%;
    object-fit: cover;
    display: block;
}

/* Search input */
:deep(.vs__search) {
    font-size: 14px;
    color: #111827;
}

:deep(.vs__search::placeholder) {
    color: #9ca3af;
}
</style>
